$(document).ready(function(){

	var slickSettings = {
		'arrows': true,
		'dots': true,
		'centerPadding': 0,
	};
  $('.carousel').slick(slickSettings);

});